import React, {useState, useEffect, useContext} from 'react';
import ReactModal from 'react-modal';
import axios from "axios";
import {getBearerToken, getServerUrl, userIsMobile} from "./utils/utils";
import {UserContext} from "./UserContext";
import {nationalParks} from "./utils/NationalParksUtils";
import {Box, FormControl, MenuItem, Select} from "@mui/material";

function ImageModal({open, modalImage, onClose, activities, imageActivity, editingTrip}) {
    const {user, updateUser} = useContext(UserContext)
    const [imageDescription, setImageDescription] = useState(modalImage?.description ? modalImage?.description : "")
    const [isProfilePicture, setIsProfilePicture] = useState(modalImage?.trip?.trip_profile_image === modalImage?.id)
    const [isUserProfilePicture, setIsUserProfilePicture] = useState(false)
    const [activityName, setActivityName] = useState(modalImage?.activity?.name)
    const [activityLocation, setActivityLocation] = useState(modalImage?.activity?.location)
    const [activityId, setActivityId] = useState(modalImage?.activity?.id)
    const [editingImage, setEditingImage] = useState(false)
    const [modalVideo, setModalVideo] = useState(null)
    const [category, setCategory] = useState(null)
    const [categoryItem, setCategoryItem] = useState(null)
    const [categoryItemDetail1, setCategoryItemDetail1] = useState(null)
    const [nationalParkTrails, setNationalParkTrails] = useState([])

    const retrieveImage = async () => {
        axios.get(`${getServerUrl()}/image/${modalImage.id}?loadCoverImage=false&shortenVideo=false`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(response => {
                const imageUrl = response.data.video_location
                setModalVideo(imageUrl);
            })
    }

    useEffect(() => {
        if (category === "National Park" && categoryItem) {
            axios.get(`${getServerUrl()}/nationalPark/${categoryItem}`, {})
                .then(response => {
                    const nationalParkInfo = JSON.parse(JSON.stringify(response.data))
                    const trails = JSON.parse(nationalParkInfo?.trails)
                    const trailNameList = trails.features.map(trail => trail.properties.TRLNAME)

                    function onlyUnique(value, index, array) {
                        return array.indexOf(value) === index;
                    }

                    var uniqueTrailNames = trailNameList.filter(onlyUnique).sort();
                    setNationalParkTrails(uniqueTrailNames)
                })
        }
    }, [categoryItem])

    useEffect(() => {
        if (modalImage) {
            setImageDescription(!isNaN(modalImage?.description) ? "" : modalImage?.description)
            setIsProfilePicture(Number(modalImage?.trip?.trip_profile_image) === Number(modalImage?.id))
            setActivityName(modalImage?.activity?.name)
            setActivityLocation(modalImage?.activity?.location)
            setActivityId(modalImage?.activity?.id)
            setCategory(modalImage?.activity?.category)
            setCategoryItem(modalImage?.activity?.categoryItem)
            setCategoryItemDetail1(modalImage?.activity?.categoryItemDetail1)
            setIsUserProfilePicture(user?.profilePictureId === modalImage?.id)
            if (modalImage.videoCoverImage) {
                retrieveImage()
            }
        }
    }, [modalImage])


    const clearState = () => {
        setImageDescription(null)
        setIsProfilePicture(null)
        setActivityLocation(null)
        setActivityName(null)
        setActivityId(null)
        setEditingImage(false)
    }
    const saveImage = async () => {
        if (isUserProfilePicture) {
            const updatedUser = {...user}
            updatedUser.profilePictureId = modalImage?.id
            updatedUser.profilePictureUrl = modalImage?.image_location
            updateUser(updatedUser)
        }

        axios.put(`${getServerUrl()}/image/${modalImage.id}`, {
            description: imageDescription,
            isProfilePicture: isProfilePicture ? true : false,
            activityId: activityId?.toString(),
            activityLocation: activityLocation,
            activityName: activityName,
            category,
            categoryItem,
            categoryItemDetail1,
            isUserProfilePicture: isUserProfilePicture ? true : false
        }, {
            headers: {
                Authorization: `Bearer ${await getBearerToken()}`
            }
        }).then(res => {
            const updatedImage = res.data
            modalImage.description = imageDescription;
            modalImage.activity = updatedImage?.activity
            modalImage.isProfilePicture = isProfilePicture
            clearState();
            onClose(modalImage, "update")
        });
    }

    const deleteImage = async () => {
        axios.delete(`${getServerUrl()}/image/${modalImage.id}`, {
            headers: {Authorization: `Bearer ${await getBearerToken()}`}
        })
            .then(res => {
                console.log("deleted image! response:", res);
            });
        clearState();
        onClose(modalImage, "delete")
    }

    const activityOptions = () => {
        let activityList = [{id: "", name: "none"}]
        if (activities) {
            activityList = activityList.concat(...activities)
        }
        return activityList.map(activity => {
            return <option value={activity.id}>{activity.name}</option>
        })
    }
    const imageUrl = modalImage?.image_location

    return (
        <ReactModal isOpen={open} id="view-image-modal">
            <div id="view-image-modal-div" style={!editingImage ? {height: "87%"} : {}}>
                {modalImage?.user?.id === user?.id && (
                    <button id="edit-image-modal-button" onClick={() => setEditingImage(!editingImage)}>
                        {editingImage ? `View ${modalImage?.fileType?.includes("video") ? "Video" : "Image"}` : `Edit ${modalImage?.fileType?.includes("video") ? "Video" : "Image"}`}
                    </button>
                )}
                <button id="close-image-modal-button" onClick={() => {
                    clearState();
                    onClose();
                }}>
                    Close
                </button>
                {(modalImage?.fileType?.includes("video") || modalImage?.videoCoverImage) ? <video
                        src={modalVideo}
                        controls autoPlay
                    /> :
                    <img src={imageUrl}/>
                }
            </div>
            {editingImage ? <div>
                    <div id="image-modal-input">
                        <label>
                            Image Description:
                            <input value={imageDescription} onChange={e => setImageDescription(e.target.value)}/>
                        </label>

                    </div>
                    <div id="image-modal-activity">
                        <label htlmFor="activitySelect">
                            Activity
                            <select id="activitySelect" value={activityId} onChange={e => {
                                setActivityId(e.target.value === "" ? null : e.target.value)
                                activities.forEach(activity => {
                                    if (activity.id === e.target.value) {
                                    }
                                    setActivityLocation(activity.location)
                                    setActivityName(activity.name)
                                })
                            }}>
                                {activityOptions()}
                            </select>
                        </label>
                        <label htmlFor="newActivityNameInput">
                            Activity Name
                            <input id="newActivityNameInput" value={activityName}
                                   onChange={e => setActivityName(e.target.value)}/>
                        </label>
                        <label htmlFor="newActivityLocationInput">
                            Activity Location
                            <input id="newActivityLocationInput" value={activityLocation}
                                   onChange={e => setActivityLocation(e.target.value)}/>
                        </label>
                        <div className="category-div-container">
                        <Box display="flex" alignItems="center" gap={2} className="category-dropdown">
                            <span>Category</span>
                            <FormControl size="small" sx={{minWidth: 200}}>
                                <Select
                                    value={category}
                                    onChange={e => setCategory(e.target.value)}
                                    displayEmpty
                                    inputProps={{'aria-label': 'Category'}}
                                    style={{background: "white"}}
                                >
                                    {["", "National Park"].map(categoryItem => (
                                        <MenuItem value={categoryItem} disabled={categoryItem === ""}
                                                  key="categoryItem">
                                            {categoryItem === "" ? "Select an activity category" : categoryItem}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        {category === "National Park" && (
                            <Box display="flex" alignItems="center" gap={2} className="category-dropdown">
                                <span>National Park Visited</span>
                                <FormControl size="small" sx={{minWidth: 200}}>
                                    <Select
                                        value={categoryItem}
                                        onChange={e => setCategoryItem(e.target.value)}
                                        displayEmpty
                                        inputProps={{'aria-label': 'Category'}}
                                        style={{background: "white"}}
                                    >
                                        {[{name: ""}, ...nationalParks].map(nationalPark => (
                                            <MenuItem value={nationalPark.name}
                                                      disabled={nationalPark.name === ""}
                                                      key="categoryItem">
                                                {nationalPark.name === "" ? "Select a National Park" : nationalPark.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        )}
                        {(category === "National Park" && categoryItem) && (
                            <Box display="flex" alignItems="center" gap={2} className="category-dropdown">
                                <span>National Park Trail Hiked</span>
                                <FormControl size="small" sx={{minWidth: 200}}>
                                    <Select
                                        value={categoryItemDetail1}
                                        onChange={e => setCategoryItemDetail1(e.target.value)}
                                        displayEmpty
                                        inputProps={{'aria-label': 'Category'}}
                                        style={{background: "white"}}
                                    >
                                        {["", ...nationalParkTrails].map(trail => (
                                            <MenuItem value={trail} disabled={trail === ""}
                                                      key="categoryItem">
                                                {trail === "" ? "Select a Hiking Trail" : trail}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        )}
                        </div>
                    </div>
                    <div id="save-image-div">
                        <label>
                            Trip Profile Picture:
                            <input type="checkbox" checked={isProfilePicture}
                                   onChange={() => setIsProfilePicture(!isProfilePicture)}/>
                        </label>
                        <label>
                            User Profile Picture:
                            <input type="checkbox" checked={isUserProfilePicture}
                                   onChange={() => setIsUserProfilePicture(!isUserProfilePicture)}/>
                        </label>
                        <button onClick={saveImage}>
                            Save photo
                        </button>
                        <button onClick={deleteImage}>
                            Delete photo
                        </button>
                    </div>
                </div> :
                <div style={{textAlign: "center"}}>
                    {isNaN(imageDescription) && (<h2>{imageDescription}</h2>)}
                    {activityName ?
                        <h4 id="view-trip-image">{activityName} — <span>{activityLocation}</span></h4> : null}
                </div>
            }

        </ReactModal>
    )
}

export default ImageModal